function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\xCDbu\xF0-detail",
  transform: "translate(-1194.000000, -1211.000000)",
  fill: "#88949D"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(1194.000000, 1211.000000)"
}, React.createElement("g", {
  id: "Group-4"
}, React.createElement("path", {
  d: "M2.23318723,8.08510638e-05 L2.23318723,18.9802723 L8.08510638e-05,18.9802723 L8.08510638e-05,22.2349319 L18.615634,22.2349319 L18.615634,18.9802723 L16.3821234,18.9802723 L16.3821234,8.08510638e-05 L2.23318723,8.08510638e-05 Z M3.04210213,18.9802723 L15.574017,18.9802723 L15.574017,0.808591489 L3.04210213,0.808591489 L3.04210213,18.9802723 Z M0.808591489,19.788783 L2.23318723,19.788783 L16.3821234,19.788783 L17.8071234,19.788783 L17.8071234,21.4264213 L0.808591489,21.4264213 L0.808591489,19.788783 Z",
  id: "Fill-1"
}), React.createElement("path", {
  d: "M13.0135447,9.75977447 C12.5668426,9.75977447 12.2046298,10.1219872 12.2046298,10.5682851 C12.2046298,11.0149872 12.5668426,11.3767957 13.0135447,11.3767957 C13.4602468,11.3767957 13.8220553,11.0149872 13.8220553,10.5682851 C13.8220553,10.1219872 13.4602468,9.75977447 13.0135447,9.75977447",
  id: "Fill-2"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "19px",
    height: "23px",
    viewBox: "0 0 19 23",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/door.388845c7.svg";
export { SvgComponent as ReactComponent };